import React from "react";

const Footer = () => {
  return (
    <div style={styles.footer}>
      © 2026 Admin Dashboard. All rights reserved.
    </div>
  );
};

const styles = {
  footer: {
    background: "transparent",
    padding: "10px 0",
    borderTop: "1px solid #ddd",
    textAlign: "center",
    fontSize: "14px",
    color: "#555",
    marginTop: "20px",
  },
};

export default Footer;